import { useEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getRoot } from 'lexical';
import { encode } from 'gpt-tokenizer';

interface CharacterCountPluginProps {
  onCountUpdate: (counts: {
    characters: number;
    words: number;
    tokens: number;
  }) => void;
}

function CharacterCountPlugin({ onCountUpdate }: CharacterCountPluginProps) {
  const [editor] = useLexicalComposerContext();

  // Función helper para calcular los contadores
  const calculateCounts = (textContent: string) => {
    const characters = textContent.length;
    const words =
      textContent.trim() === '' ? 0 : textContent.trim().split(/\s+/).length;
    const tokens = textContent.trim() === '' ? 0 : encode(textContent).length;

    return { characters, words, tokens };
  };

  // Efecto para leer el contenido INICIAL al montar
  useEffect(() => {
    editor.getEditorState().read(() => {
      const root = $getRoot();
      const textContent = root.getTextContent();
      const counts = calculateCounts(textContent);
      onCountUpdate(counts);
    });
  }, [editor, onCountUpdate]);

  // Efecto para escuchar CAMBIOS posteriores
  useEffect(() => {
    return editor.registerUpdateListener(({ editorState }) => {
      editorState.read(() => {
        const root = $getRoot();
        const textContent = root.getTextContent();
        const counts = calculateCounts(textContent);
        onCountUpdate(counts);
      });
    });
  }, [editor, onCountUpdate]);

  return null;
}

export default CharacterCountPlugin;
